import { Injectable } from '@angular/core';
import { BaseHttpService } from 'src/app/shared/base-http/base-http.service';
import { PageOptions } from 'src/app/shared/data-table/data-table.interface';
import { config } from 'src/config/config';
import { getEnv } from 'src/modules/utility';
import { EcmService } from '../ecm.service';

interface MultiEditToolChange {
   chkNecLec: number;
   chkToolAffected: number;
   chkCertDataAffected: number;
   chkTlLeadRelLvl: number;
   chkDtShippedToDataBank: number;
   chkDesignSourceId: number;
   designSourceId: number;
   dtShippedToDatabank: string;
   sourceName: string;
   necLec: string;
   tlLeadRelLvl: string;
   certDataAffected: number;
   toolAffected: number;
}

@Injectable()
export class EcmToolChangeService {

   constructor(
      private readonly baseHttpService: BaseHttpService
   ) { }

   public multiEditToolChange(body: MultiEditToolChange[]) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}ecm/multi-edit`;
      return this.baseHttpService.put(url, body);
   }

   public getToolChange(toolId: number, pageOptions?: PageOptions) {
      if (!pageOptions) {
         pageOptions = {
            page: 0,
            order: 'asc',
            size: 10,
            sort: 'necLec',
         };
      }

      const params = this.baseHttpService.generateHttpParams({
         page: pageOptions.page,
         size: pageOptions.size,
         sort: pageOptions.sort,
         order: pageOptions.order,
         toolId: toolId
      });

      const url = `${config.tprecmApiBaseUrl[getEnv()]}ecm/tool-change`;
      return this.baseHttpService.get(url, { params: params });
   }

   public addEcmToolChange(body: any) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}ecm/tool-change`;
      return this.baseHttpService.post(url, body);
   }

   public addAuthority(body: any) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}ecm/authorities`;
      return this.baseHttpService.post(url, body);
   }

   public updateAuthority(body: any) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}ecm/authorities`;
      return this.baseHttpService.put(url, body);
   }

   public deleteAuthority(authId, toolChangeId) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}ecm/authorities/${authId}/${toolChangeId}`;
      return this.baseHttpService.delete(url);
   }

    /**
     * Modify an existing tool change
     *
     * @param {*} body
     * @returns
     * @memberof EcmToolsService
     */
    public updateToolChange(body: any) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}ecm/tool-change`;
        return this.baseHttpService.put(url, body);
    }

    /**
     * Remove an existing tool change
     *
     * @param {number} toolChangeId
     * @returns
     * @memberof EcmToolChangeService
     */
    public deleteToolChange(toolId: number, toolChangeId: number) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}ecm/tool-change/${toolChangeId}/${toolId}`;
        return this.baseHttpService.delete(url);
    }
}
